module.exports = __webpack_public_path__ + "img/company-placeholder.36caa15f.svg";